const AUDIO_STATUSES = {
  CORRECT: 'CORRECT',
  ERROR: 'ERROR',
  CONVERSION_PENDING: 'CONVERSION_PENDING',
  CONVERSION_RESTART_POSSIBLE: 'CONVERSION_RESTART_POSSIBLE',
  DUPLICATE: 'DUPLICATE',
}

export default AUDIO_STATUSES
